import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateAudioJson(audioJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // AudioJson => RichAssetAudio => RichAsset => Node
    const parentNode = audioJson.$container?.$container?.$container;
    const idField = getId(parentNode);
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: audioJson,
        allProperties: audioJson.properties,
        requiredProperties: [ast.TypeStaticProperty, ast.UrlProperty],
        parentNode,
        accept,
    });
    const urlProperty = audioJson.properties.find((prop) => {
        return ast.isUrlProperty(prop);
    });
    const loopProperty = audioJson.properties.find((prop) => {
        return ast.isLoopProperty(prop);
    });
    // The url should start with https.
    const url = urlProperty?.url?.value?.toLowerCase();
    if (url && url.startsWith('https://') === false) {
        accept('error', `URL should point to a secure (https) location.`, {
            node: audioJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
    // The loop value if present should be from 0 up to 1000
    const loopStr = loopProperty?.loop?.value;
    const loopNum = loopStr ? Number(loopStr) : 0;
    if (isNaN(loopNum) ||
        Number.isInteger(loopNum) === false ||
        loopNum < 0 ||
        loopNum > 1000) {
        accept('error', `Loop value '${loopStr}' is invalid. It needs to be an integer from 0 up to 1000.`, {
            node: audioJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
//# sourceMappingURL=audio.js.map